module.exports = __webpack_public_path__ + "static/media/29ADMSPC9.95df6a2b.jpg";